import { createAsyncAction } from 'src/redux/actions';

export const FetchWorkspaces = createAsyncAction('dashboard/FETCH_WORKSPACES');
export const FetchAndSelectWorkspace = createAsyncAction(
  'dashboard/FETCH_AND_SELECT_WORKSPACE'
);
export const CLEAR_FILTERED_WORKSPACES = `dashboard/CLEAR_FILTERED_WORKSPACES`;
export const SELECT_WORKSPACE = `dashboard/SELECT_WORKSPACE`;
